module.exports = __webpack_public_path__ + "img/guide03.4db03f4d.png";